import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = `${process.env.REACT_APP_BACKEND_URL}`;

export const aiApi = createApi({
  reducerPath: 'aiApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
    timeout: 90000, // 90 seconds timeout for long-running AI operations
  }),
  tagTypes: ['Summary', 'Pdf'],
  endpoints: (builder) => ({
    // Generate AI summary for a client
    generateSummary: builder.mutation({
      query: (clientId) => ({
        url: '/ai/summary',
        method: 'POST',
        body: { client_id: clientId },
      }),
      providesTags: (result, error, clientId) => [{ type: 'Summary', id: clientId }],
    }),

    // Generate PDF report for a client
    generatePdf: builder.mutation({
      query: (clientId) => ({
        url: '/ai/summary/pdf',
        method: 'POST',
        body: { client_id: clientId },
      }),
      providesTags: (result, error, clientId) => [{ type: 'Pdf', id: clientId }],
    }),
  }),
});

export const { useGenerateSummaryMutation, useGeneratePdfMutation } = aiApi;
